/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmProxyImplementationContractInfo } from './EvmProxyImplementationContractInfo';

export type EvmProxyContractV2Info = {
    PRXTP: EvmProxyContractV2Info.PRXTP;
    PRRXTP: EvmProxyContractV2Info.PRRXTP;
    IPADDRLIST: Array<EvmProxyImplementationContractInfo>;
    ISIMPLVRFD: EvmProxyContractV2Info.ISIMPLVRFD;
    IMPLABI: string;
};

export namespace EvmProxyContractV2Info {

    export enum PRXTP {
        Y = 'Y',
        N = 'N',
    }

    export enum PRRXTP {
        MINIMAL = 'MINIMAL',
        TRANSPARENT = 'TRANSPARENT',
        BEACON = 'BEACON',
        TRANSPARENT_BEACON_TRANSPARENT = 'TRANSPARENT_BEACON_TRANSPARENT',
        SLOT_BASED = 'SLOT_BASED',
    }

    export enum ISIMPLVRFD {
        Y = 'Y',
        N = 'N',
    }


}

